import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CardState, ProductActivityRow } from "../card-types";

@Component({
  selector: "product-activity-card",
  templateUrl: "./product-activity-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class ProductActivityCardComponent {
  @Input() title: string;
  @Input() hint: string;
  @Input() state: CardState<ProductActivityRow>;
  @Input() noDataMessage: string = "Nothing to see here yet.";
  @Input() showExport: boolean = true;
  @Input() showDashboardLink: boolean = false;
  @Input() isReport: boolean = false;
  @Input() comingSoon: boolean = false;
  @Output() exportClick = new EventEmitter<void>();
  @Output() dashboardClick = new EventEmitter<void>();

  trackByIndex(index: number): number {
    return index;
  }
}
